import { HttpClient, HttpParams } from '@angular/common/http';
import { Parametrage } from './parametrage.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LigneParametrage } from './ligne-parametrage.interface';
import { InjectionToken } from '@angular/core';

export const PARAMETRAGE_SERVICE_TOKEN = new InjectionToken<AbstractParametrageService>('Token d\'injection du service de paramétrage');

export abstract class AbstractParametrageService {

	constructor(protected http: HttpClient, protected url = 'ws/parametrages') {
	}

	/**
	 * Récupère le paramétrage de l'application.
	 */
	public recupererParametrage(): Observable<Parametrage> {
		const params = new HttpParams()
			.set('use-case', 'affichage');
		return this.http.get<Parametrage>(this.url, { params: params })
			.pipe(map(parametrage => new Parametrage().deserialize(parametrage)));
	}

	/**
	 * Mettre à jour les lignes de paramétrage.
	 *
	 * @param ligneParametrages les lignes de paramétrage.
	 */
	public mettreAJour(ligneParametrages: LigneParametrage[]): Observable<void> {
		return this.http.put<void>(this.url, ligneParametrages);
	}

}
